import { cloneDeep } from 'lodash';

const state = {
  list: [],
  product: {},
  lookups: {},
  fourover_list: [],
  materials_by_category: [],
  fourover_filter: {},
  fourover_master_accounts: []
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  product: (state) => {
    return state.product || {};
  },
  lookups: (state) => {
    return state.lookups || {};
  },
  stocks: (state, getters) => {
    return getters.lookups.stocks || [];
  },
  finishes: (state, getters) => {
    return getters.lookups.finishes || [];
  },
  materials: (state, getters) => {
    return getters.lookups.materials || [];
  },
  option_groups: (state, getters) => {
    return getters.lookups.option_groups;
  },
  option_group_name: (state, getters) => (id) => {
    return getters.option_groups.filter((x) => x.id === id).map((x) => x.name)[0];
  },
  connected: (state, getters) => (coreProductId) => {
    return getters.list.filter((x) => x.coreProducts.filter((y) => y.id === coreProductId).length);
  },
  available: (state, getters) => (width, height) => {
    return getters.list.filter(
      (x) =>
        (x.height === height && x.width === width) || (x.height === width && x.width === height)
    );
  },
  fourover_list: (state) => {
    return state.fourover_list || [];
  },
  materials_by_category: (state) => {
    return state.materials_by_category || [];
  },
  fourover_filter: (state) => {
    return state.fourover_filter || {};
  },
  category_materials: (state, getters, rootState, rootGetters) => {
    const items = [];
    for (var category of rootGetters['lookup/categories']) {
      const materials = getters.materials.filter((x) =>
        x.possibleCategoryIds.includes(category.id)
      );
      for (var material of materials) {
        items.push({
          tempId: `${category.id}|${material.id}`,
          category,
          material,
          text:
            material.names.filter((y) => y.categoryId === category.id).map((y) => y.text)[0] || '',
          description:
            material.names
              .filter((y) => y.categoryId === category.id)
              .map((y) => y.description)[0] || '',
          baseTraits: material.traits.filter((y) => !y.categoryId).length,
          traits: material.traits.filter((y) => y.categoryId === category.id).length
        });
      }
    }
    return items;
  },
  fourover_master_accounts: (state) => {
    return state.fourover_master_accounts || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_PRODUCT(state, item) {
    state.product = item;
  },
  DELETE_PRODUCT(state, id) {
    const index = state.list.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  DELETE_QUANTITY(state, id) {
    const index = state.product.quantities.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.product.quantities.splice(index, 1);
    }
  },
  SET_LOOKUPS(state, item) {
    state.lookups = item;
  },
  SET_FOUROVER_LIST(state, list) {
    state.fourover_list = list;
  },
  SET_OPTION(state, item) {
    if (state.lookups.options) {
      const index = state.lookups.options.findIndex((x) => x.id === item.id);
      if (index >= 0) {
        this._vm.$set(state.lookups.options, index, item);
      }
    }
  },
  SET_MATERIAL_TRAIT(state, trait) {
    if (state.lookups.materials) {
      const index = state.lookups.materials.findIndex((x) => x.id === trait.materialId);
      if (index >= 0) {
        const traitIndex = state.lookups.materials[index].traits.findIndex(
          (x) => x.id === trait.id
        );
        if (traitIndex >= 0) {
          this._vm.$set(state.lookups.materials[index].traits, traitIndex, trait);
        } else {
          state.lookups.materials[index].traits.push(trait);
        }
      }
    }
    if (state.materials_by_category) {
      const index = state.materials_by_category.findIndex((x) => x.id === trait.materialId);
      if (index >= 0) {
        const traitIndex = state.materials_by_category[index].traits.findIndex(
          (x) => x.id === trait.id
        );
        if (traitIndex >= 0) {
          this._vm.$set(state.materials_by_category[index].traits, traitIndex, trait);
        } else {
          state.materials_by_category[index].traits.push(trait);
        }
      }
    }
  },
  SET_MATERIAL_NAME(state, name) {
    if (!state.lookups.materials) return;
    const index = state.lookups.materials.findIndex((x) => x.id === name.materialId);
    if (index >= 0) {
      if (!state.lookups.materials[index].names) return;
      const traitIndex = state.lookups.materials[index].names.findIndex((x) => x.id === name.id);
      if (traitIndex >= 0) {
        this._vm.$set(state.lookups.materials[index].names, traitIndex, name);
      } else {
        state.lookups.materials[index].names.push(name);
      }
    }
  },
  SET_MATERIAL(state, material) {
    if (!state.lookups.materials) return;
    const index = state.lookups.materials.findIndex((x) => x.id === material.id);
    if (index >= 0) {
      this._vm.$set(state.lookups.materials, index, material);
    } else {
      state.lookups.materials.push(material);
    }
  },
  DELETE_MATERIAL_TRAIT(state, req) {
    if (!state.lookups.materials) return;
    const index = state.lookups.materials.findIndex((x) => x.id === req.materialId);
    if (index >= 0) {
      const traitIndex = state.lookups.materials[index].traits.findIndex((x) => x.id === req.id);
      if (traitIndex >= 0) {
        state.lookups.materials[index].traits.splice(traitIndex, 1);
      }
    }
  },
  DELETE_MATERIAL_NAME(state, req) {
    const index = state.lookups.materials.findIndex((x) => x.id === req.materialId);
    if (index >= 0) {
      const nameIndex = state.lookups.materials[index].names.findIndex((x) => x.id === req.id);
      if (nameIndex >= 0) {
        state.lookups.materials[index].names.splice(nameIndex, 1);
      }
    }
  },
  SET_FOUROVER_PRODUCT(state, item) {
    const index = state.fourover_list.findIndex((x) => x.externalId === item.externalId);
    if (index >= 0) {
      this._vm.$set(state.fourover_list, index, item);
    }
  },
  CONNECT_CORE_PRODUCT(state, item) {
    const index = state.list.findIndex((x) => x.id === item.printProductId);
    if (index >= 0) {
      const cpIndex = state.list[index].coreProducts.findIndex((x) => x.id === item.coreProductId);
      if (cpIndex < 0) {
        state.list[index].coreProducts.push({
          id: item.coreProductId
        });
      }
    }
  },
  DISCONNECT_CORE_PRODUCT(state, item) {
    const index = state.list.findIndex((x) => x.id === item.printProductId);
    if (index >= 0) {
      const cpIndex = state.list[index].coreProducts.findIndex((x) => x.id === item.coreProductId);
      if (cpIndex >= 0) {
        state.list[index].coreProducts.splice(cpIndex, 1);
      }
    }
  },
  SET_MATERIALS(state, list) {
    state.materials_by_category = list || [];
  },
  SET_FOUROVER_FILTER(state, filter) {
    state.fourover_filter = cloneDeep(filter);
  },
  IGNORE_FOUROVER_LIST(state, ids) {
    state.fourover_list = state.fourover_list.filter((x) => !ids.includes(x.id));
  },
  FOUROVER_MASTER_ACCOUNTS(state, list) {
    state.fourover_master_accounts = list;
  },
  SET_STOCK(state, item) {
    if (!state.lookups.stocks) return;
    const index = state.lookups.stocks.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.lookups.stocks, index, item);
    }
  },
  SET_FINISH(state, item) {
    if (!state.lookups.finishes) return;
    const index = state.lookups.finishes.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.lookups.finishes, index, item);
    }
  }
};

const actions = {
  getAllProducts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('print/getAllProducts')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLookups({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('print/getLookups')
        .then((response) => {
          commit('SET_LOOKUPS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMaterialsByCategory({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`print/getMaterialsByCategory?categoryId=${categoryId}`)
        .then((response) => {
          commit('SET_MATERIALS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`print/getProduct?id=${id}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addProduct({ commit }, product) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/addProduct', product)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`print/deleteProduct?id=${id}`)
        .then(() => {
          commit('DELETE_PRODUCT', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  saveQuantity({}, quantity) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/saveQuantity', quantity)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteQuantity({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`print/deleteQuantity?id=${id}`)
        .then(() => {
          commit('DELETE_QUANTITY', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`print/refresh?id=${id}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  override({}, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('print/override', req)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addOptionImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`print/addOptionImage?optionId=${req.optionId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_OPTION', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveMaterialTrait({ commit }, trait) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/saveMaterialTrait', trait)
        .then((res) => {
          commit('SET_MATERIAL_TRAIT', res.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveMaterialName({ commit }, name) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/saveMaterialName', name)
        .then((res) => {
          commit('SET_MATERIAL_NAME', res.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  savePrintImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`print/savePrintImage?type=${req.type}&id=${req.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          switch (req.type) {
            case 'materials':
              commit('SET_MATERIAL', response.data);
              break;
            case 'stocks':
              commit('SET_STOCK', response.data);
              break;
            case 'finishes':
              commit('SET_FINISH', response.data);
              break;
          }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  moveToBaseTrait({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`print/moveToBaseTrait?id=${id}`)
        .then((response) => {
          commit('SET_MATERIAL_TRAIT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteMaterialTrait({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`print/deleteMaterialTrait?id=${req.id}`)
        .then(() => {
          commit('DELETE_MATERIAL_TRAIT', req);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteMaterialName({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`print/deleteMaterialName?id=${req.id}`)
        .then(() => {
          commit('DELETE_MATERIAL_NAME', req);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCoreProducts({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`print/updateCoreProducts?id=${req.productId}`, req.coreProducts)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  connect({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('print/connectCoreProduct', req)
        .then(() => {
          commit('CONNECT_CORE_PRODUCT', req);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  disconnect({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('print/disconnectCoreProduct', req)
        .then(() => {
          commit('DISCONNECT_CORE_PRODUCT', req);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getFourOverProducts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('print/getFourOverProducts')
        .then((response) => {
          commit('SET_FOUROVER_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  refreshFourOverProducts({}, masterAccountId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`print/refreshFourOverProducts?masterAccountId=${masterAccountId}`)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getFourOverMasterAccounts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('print/getFourOverMasterAccounts')
        .then((response) => {
          commit('FOUROVER_MASTER_ACCOUNTS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ignoreFourOverProducts({ commit }, ids) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/ignoreFourOverProducts', ids)
        .then(() => {
          commit('IGNORE_FOUROVER_LIST', ids);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addFourOverProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`print/addFourOverProduct?id=${id}`)
        .then((response) => {
          commit('SET_FOUROVER_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addFourOverProducts({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('print/addFourOverProducts', req)
        .then((response) => {
          for (var product of response.data) {
            commit('SET_FOUROVER_PRODUCT', product);
          }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setFourOverFilter({ commit }, filter) {
    commit('SET_FOUROVER_FILTER', filter);
  },
  // eslint-disable-next-line no-empty-pattern
  saveOptionShow({}, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('print/saveOptionShow', {}, { params: req })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  saveOptionDefault({}, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('print/saveOptionDefault', {}, { params: req })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
